import React, { Component } from "react"
import * as path from "../../constants/Paths"
import { instanceOf } from "prop-types"
import { withCookies, Cookies } from "react-cookie"
import LoginLink from "../common/loginLink"
import * as endpoint from "../../constants/Endpoints"
import * as tracking from "../../../booking/helpers/tracking"

import config from "react-global-configuration"
import SiteHeader from "../../../styleguide/js/components/site-header"

class AmendProgressIndicator extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      isMobileMenuActive: false,
      isMobileLoginDropdownActive: false,
      isLoginActive: false,
    }
  }

  componentDidMount() {
    this.props.handleCurrentStep(this.props.step)
    new SiteHeader({ el: this.containerRef.current })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.step !== this.props.step) {
      this.props.handleCurrentStep(this.props.step)
    }
    const { isMobileMenuActive } = this.state
    const root = document.getElementsByTagName("html")[0]
    if (isMobileMenuActive) {
      root.classList.add("is-mobilenav-mode")
      root.classList.add("is-sticky-mode")
    } else {
      if (root.classList.contains("is-mobilenav-mode")) root.classList.remove("is-mobilenav-mode")
      if (root.classList.contains("is-sticky-mode")) root.classList.remove("is-sticky-mode")
    }
  }

  handleMobileMenuActiveToggle = () => {
    this.setState({ isMobileMenuActive: !this.state.isMobileMenuActive })
  }

  handleLoginDropdownToggle = () => {
    this.setState({ isMobileLoginDropdownActive: !this.state.isMobileLoginDropdownActive })
  }

  handleLogout = () => {
    this.props.handleLogOut()
    this.setState({ isMobileMenuActive: false })
  }

  getProgressClassName(step, currentStep) {
    if (step < currentStep) {
      return "is-complete"
    } else if (step === currentStep) {
      return "is-active"
    } else {
      return ""
    }
  }

  handleOnClick = (step, currentStep, event) => {
    if (this.getProgressClassName(step, currentStep) === "") {
      return event.preventDefault()
    } else {
      return true
    }
  }

  render() {
    const { userAccountDetails } = this.props
    const { step: currentStep } = this.props
    const { isMobileMenuActive, isMobileLoginDropdownActive } = this.state
    const textKeys = config.get("textKeys.progressIndicator") || {}
    const headerMenuTextKeys = config.get("textKeys.headerMenu") || {}
    const extraServicesTextKeys = config.get("textKeys.extraServices") || {}
    const amendmentTextKeys = config.get("textKeys.amendment.manage") || {}
    const showExtraServicesStep = extraServicesTextKeys.showExtraServicesStep
    const trackingStep = this.props.step + 1
    const editTime = this.props.editTime

    let editInfo
    if (editTime) {
      editInfo = (
        <nav className="edit-info">
          <p className="left">{amendmentTextKeys.ribbonEditText || "du redigerer"}</p>
          <p className="right">{this.props.ammendmentReference}</p>
        </nav>
      )
    } else {
      editInfo = null
    }

    let stepOneActive = ""
    let stepTwoActive = ""
    let stepThreeActive = ""
    let stepFourActive = ""
    switch (currentStep) {
      case 1:
        stepOneActive = "-active"
        break
      case 2:
        stepOneActive = "-active"
        stepTwoActive = "-active"
        break
      case 3:
        stepOneActive = "-active"
        stepTwoActive = "-active"
        stepThreeActive = "-active"
        break
      case 4:
        stepOneActive = "-active"
        stepTwoActive = "-active"
        stepThreeActive = "-active"
        stepFourActive = "-active"
        break
      default:
        break
    }

    return (
      <div className="site-header-wrapper">
        <header className={`site-header js--site-header is-home ${isMobileMenuActive ? "is-sticky" : ""}`} ref={this.containerRef}>
          <div className="progress-container">
            <div className={`progress-indication-step${stepOneActive}`}></div>
            <div className={`progress-indication-step${stepTwoActive}`}></div>
            <div className={`progress-indication-step${stepThreeActive}`}></div>
            <div className={`progress-indication-step${stepFourActive}`}></div>
          </div>

          <nav className="checkout-navigation checkout-navigation--parking rm-this-class rm-this-class-hide-default">
            <a
              className="checkout-navigation__close button button--nav button--nav-underline"
              href={
                textKeys.returnBookingLink ||
                path.AMMEND_SEARCH() + `?email=${this.props.ammendmentEmail}&reference=${this.props.ammendmentReference}`
              }
              onClick={() => tracking.trackParkingFlowClick("close booking", "step " + trackingStep, this.props)}
            >
              <span className="text">{textKeys.returnToBooking || "Tilbage"}</span>
            </a>

            {/*Checkout navigation steps from regular progressIndicator was here.*/}

            <ul className="checkout-navigation__close button button--nav button--nav-underline end">
              <li className="main-navigation__item main-navigation__item--user">
                {userAccountDetails ? (
                  userAccountDetails.ContactDetails ? (
                    <React.Fragment>
                      {/* route to 'min side'? */}
                      <a className="button button--nav" href={headerMenuTextKeys.myPage}>
                        {/* {console.debug(textKeys.myPage)} */}
                        <span className="text name">
                          {userAccountDetails.ContactDetails.FirstName || userAccountDetails.ContactDetails.LastName
                            ? userAccountDetails.ContactDetails.FirstName + " " + userAccountDetails.ContactDetails.LastName
                            : userAccountDetails.EmailAddress}
                        </span>
                      </a>
                    </React.Fragment>
                  ) : (
                    <div className="button button--nav">
                      <span className="text">{textKeys.crmOffline || "Sorry CRM is offline ..."}</span>
                    </div>
                  )
                ) : (
                  <LoginLink
                    {...this.props}
                    loginurl={endpoint.ACCOUNT_LOGIN()}
                    linkClassName={"button button--nav button--nav-underline"}
                    spanClassName={"text"}
                    linkText={textKeys.login || "Log ind"}
                    trackingHandler={() => tracking.trackCTALoginButtonClick("parking - booking flow header")}
                  />
                )}
              </li>
            </ul>
          </nav>
          {editInfo}
        </header>
      </div>
    )
  }
}
export default withCookies(AmendProgressIndicator)
